module.exports = __webpack_public_path__ + "static/buy2-b91993ed35216dbadf04a62800663235.jpg";